import { db } from '../client/index';
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc, query, where } from 'firebase/firestore/lite';
import { format, add } from 'date-fns';

const salesCollection = collection(db, 'sales');

export const getSales = async (date) => {
  try {
    const day = format(date, 'yyyy-MM-dd');
    const dayNext = format(add(date, { days: 1 }), 'yyyy-MM-dd');
    const salesQuery = query(salesCollection, where('date', '>=', day), where('date', '<', dayNext));
    const salesSnapshot = (await getDocs(salesQuery)).docs;
    const salesItems = salesSnapshot.map(sale => ({
      ...sale.data(),
      id: sale.ref.id
    }));
    return salesItems;
  } catch (err) {
    return err;
  }
}

export const resumeByDay = async (date) => {
  try {
    const day = format(date, 'yyyy-MM-dd');
    const dayNext = format(add(date, { days: 1 }), 'yyyy-MM-dd');
    const salesQuery = query(
      salesCollection,
      where('date', '>=', day),
      where('date', '<', dayNext),
    );
    const salesSnapshot = (await getDocs(salesQuery)).docs;
    const resume = salesSnapshot
      .map(saleRef => saleRef.data())
      .filter(sale => sale.status === 'completed')
      .map(({ items, total, paymentMethod, extra }) => ({
        items,
        total,
        extra,
        paymentMethod
      }));
    return resume;
  } catch (err) {
    return err;
  }
}

export const getSale = async (id) => {
  try {
    const saleSnapshot = doc(db, 'sales', id);
    const roleItem = await getDoc(saleSnapshot);
    return roleItem.exists() ? roleItem.data() : null;
  } catch (err) {
    return err;
  }
}

export const createSale = async (sale) => {
  try {
    const { id } = await addDoc(salesCollection, sale);
    const saleAdded = { id, ...sale };
    return saleAdded;
  } catch (err) {
    return err;
  }
}

export const updateSale = async (id, sale) => {
  try {
    const saleRef = doc(db, 'sales', id);
    await updateDoc(saleRef, sale);
    return { id, ...sale };
  } catch (err) {
    return err;
  }
}

export const deleteSale = async (id) => {
  try {
    const saleRef = doc(db, 'sales', id);
    await deleteDoc(saleRef);
    return id;
  } catch (err) {
    return err;
  }
}